import {
  Categories,
  SubclassType,
  TableForSearchItem,
  WordEntityTypeWithParentKeys,
  WordNameDictionary,
  WordTableItemType,
  WordTableType,
  WordTableTypeWithParentKeys,
} from "./type";
import { Lang } from "@noli/core";
import { Dictionary } from "@/types/base";

export const categoryMap: Record<Categories, { label: Record<Lang, string> }> = {
  people: {
    label: {
      zh: "人物人像",
      en: "People",
    },
  },
  object: {
    label: {
      zh: "物体事物",
      en: "Object",
    },
  },
  scenery: {
    label: {
      zh: "风景场景",
      en: "Scenery",
    },
  },
};

export const formatTableData = (data: WordTableType): WordTableTypeWithParentKeys => {
  return data.map((item) => {
    const rootKey = item.key;
    const newItem: WordTableItemType<WordEntityTypeWithParentKeys> = {
      key: item.key,
    };

    if (item.subclass) {
      newItem.subclass = item.subclass.map((sub) => {
        const subKey = sub.key;
        const newSub: SubclassType<WordEntityTypeWithParentKeys> = {
          key: sub.key,
          children: sub.children.map((child) => {
            return { ...child, parentKeys: [subKey, rootKey] };
          }),
        };
        return newSub;
      });
    }
    if (item.children) {
      newItem.children = item.children.map((child) => {
        return { ...child, parentKeys: [rootKey] };
      });
    }

    return newItem;
  });
};

/**
 * 打平数据以搜索
 * @param data
 * @returns
 */
export const getTableForSearch = (data: WordTableType) => {
  const flattenArray = data.reduce<TableForSearchItem[]>((list, item) => {
    const rootKey = item.key;
    if (item.subclass) {
      for (let i = 0; i < item.subclass.length; i++) {
        const sub = item.subclass[i];
        const subKey = sub.key;
        if (sub.children) {
          sub.children.forEach((child) => {
            list.push({ ...child, parentKeys: [subKey, rootKey] });
          });
        }
      }
    }
    if (item.children) {
      item.children.forEach((child) => {
        list.push({ ...child, parentKeys: [rootKey] });
      });
    }

    return list;
  }, []);
  return flattenArray;
};

export const getKeyValueMap = (data: WordTableType) => {
  return data.reduce<Dictionary>((map, item) => {
    if (item.subclass) {
      for (let i = 0; i < item.subclass.length; i++) {
        const sub = item.subclass[i];
        if (sub.children) {
          sub.children.forEach((child) => {
            map[child.key] = child.value;
          });
        }
      }
    }
    if (item.children) {
      item.children.forEach((child) => {
        map[child.key] = child.value;
      });
    }
    return map;
  }, {});
};

export const searchFilter =
  (list: TableForSearchItem[], names: WordNameDictionary) =>
  (value = "") => {
    const resultSet = new Set();
    const result = list.filter((item) => {
      if (resultSet.has(item.key)) return false;
      resultSet.add(item.key);
      return (
        names[item.key].en.toLowerCase().includes(value.toLowerCase()) ||
        names[item.key].zh.includes(value) ||
        item.value.toLowerCase().includes(value.toLowerCase())
      );
    });
    return result;
  };

export const wordRecordSubmitFilter = (text: string, record: string, keyValueMap: Dictionary) => {
  const keys = record.split("|");
  const wordKey = keys[keys.length - 1]?.trim();
  if (!wordKey) return false;
  const wordValue = keyValueMap[wordKey];
  const words = text.split(",").map((str) => str.trim());
  const isChecked = words?.includes(wordValue);
  return isChecked;
};
